import { createFileRoute } from '@tanstack/react-router';
import { DevicesPage, merchantDevicesQueryOptions } from '@/features/devices';

export const Route = createFileRoute('/_authed/devices')({
  loader: ({ cause, context }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(merchantDevicesQueryOptions());
  },
  component: DevicesRouteComponent,
});

function DevicesRouteComponent() {
  return <DevicesPage />;
}
